/** Display helpers shared by the AI models admin UI. */

import { REPORT_TIME_ZONE } from "@/lib/llm-models/cost-filters";

export function usd(n: number): string {
  if (n === 0) return "$0";
  if (n < 0.01) return `$${n.toFixed(4)}`;
  return `$${n.toFixed(n < 1 ? 3 : 2)}`;
}

export function perMillion(n: number): string {
  return `$${n < 1 ? n.toFixed(3).replace(/0$/, "") : n.toFixed(2)}`;
}

const EFFORT_LABELS: Record<string, string> = {
  none: "None",
  minimal: "Minimal",
  low: "Low",
  medium: "Medium",
  high: "High",
  xhigh: "Extra high",
  max: "Max",
};

export function effortLabel(effort: string): string {
  return EFFORT_LABELS[effort] ?? effort;
}

export function formatDateTime(value: string | number): string {
  return new Date(value).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
}


/**
 * A spend amount sent as a decimal string. Totals of $1 or more get 2 decimals; anything smaller
 * keeps up to 4 significant digits, since one call often costs a fraction of a cent.
 */
export function costUsd(value: string): string {
  const n = Number(value);
  if (!Number.isFinite(n) || n === 0) return "$0";
  if (Math.abs(n) >= 1) return `$${n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  return `$${n.toLocaleString("en-US", { maximumSignificantDigits: 4, maximumFractionDigits: 20 })}`;
}

export function formatPakistanTime(value: string | number): string {
  return new Date(value).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short", timeZone: REPORT_TIME_ZONE });
}

/** A token count in short form: 950, 12.4K, 3.1M. */
export function tokens(n: number): string {
  return n.toLocaleString("en-US", { notation: "compact", maximumFractionDigits: 1 });
}

export function plural(n: number, one: string, many = `${one}s`): string {
  return `${n.toLocaleString()} ${n === 1 ? one : many}`;
}
